export default __webpack_public_path__ + "static/tutor-screen@0.5x-3e89d6506bff237f27929a8eac080366.png";